export const ComponentsConfig = [
  {
    key: 'app-bell',
    enabledByRight: ['show-notification-bell'],
  },
];
